export const AppSumoProductsLink = "https://appsumo.com/account/products";
